import React from 'react';
import { ContactUsIcon } from './ContactUsIcons';

type OptionCardProps = {
    iconKey: string;
    title: string;
    description: React.ReactNode;
    buttonText: string;
    onClick: () => void;
    isBlurred?: boolean;
    unavailableText?: string;
    iconSize?: number;
};

export const OptionCard: React.FC<OptionCardProps> = ({ iconKey, title, description, buttonText, onClick, isBlurred, unavailableText, iconSize = 22 }) => (
    <div className={`contact-us-card ${isBlurred ? 'is-blurred' : ''}`}>
        {isBlurred && unavailableText && (
            <span className="contact-us-card__unavailable">{unavailableText}</span>
        )}
        <div className="contact-us-card__icon">
            <ContactUsIcon iconKey={iconKey} size={iconSize} />
        </div>
        <div className="contact-us-card__content">
            <div className="contact-us-card__title-row">
                <span className="contact-us-card__title">{title}</span>
            </div>
            <p className="contact-us-card__description">{description}</p>
            <button onClick={isBlurred ? undefined : onClick} disabled={isBlurred} className="contact-us-card__btn">{buttonText}</button>
        </div>
    </div>
);
